module.exports = __webpack_public_path__ + "static/media/chapeldown-logo-1.3e389701.avif";